import React, { useState } from 'react';
import Lottie from 'react-lottie';
import MainTaro from '../../Json/data.json';

const lottieOptions = {
    animationData: MainTaro,
    loop: true,
    autoplay: true,
    rendererSettings: {
        className: 'add-class', // svg에 적용
        preserveAspectRatio: 'xMidYMid slice'
    }
};

const ThumbsUpComponent = () => {

    return (
        <div className="thumbs-up">
            <Lottie
                options={lottieOptions}
                isClickToPauseDisabled={false}
                style={{width: '315px', height: '200px'}} // svg의 부모 div에 적용
                eventListeners={[
                    {
                        eventName: 'complete',
                        callback: () => console.log('the animation completed'),
                    },
                ]}
            />
        </div>
    )
}

export default ThumbsUpComponent;